import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface StillHereResponse {
  nextCheckAt: string;
  maxClockOutTime: string;
  message: string;
}

@Injectable({ providedIn: 'root' })
export class StillHereService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = '/api/Contractors/me/shifts';

  respondStillHere(shiftId: string): Observable<StillHereResponse> {
    return this.http.post<StillHereResponse>(
      `${this.apiUrl}/${shiftId}/still-here`,
      {}
    );
  }
}
